"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tableModificators = void 0;
exports.tableModificators = {
    row: (row) => !row.original.isActive ? 'not-active' : undefined,
    column: (column) => column.disableShowForDevice ? 'device-hidden' : undefined,
};
//# sourceMappingURL=utils.js.map